import { useState } from "react"
import { PiMagnifyingGlassDuotone } from 'react-icons/pi'

import Modal from "../../shared/modal/Modal"
import NcmSearchModal from './NcmSearchModal'

import '../../shared/css/inputGroup.css'

// Campo de NCM com um botão de busca colado, como se fosse uma peça só —
// abre um modal de busca na tabela oficial (ver NcmSearchModal.js).
function NcmSearchTrigger({ name, value, handleOnChange, onSelect, suggestQuery }) {
    const [modalNcm, setModalNcm] = useState(false)

    function handlePicked(n) {
        onSelect(n)
        setModalNcm(false)
    }

    return (
        <>
            <div className="ncm-input-group">
                <input className="input ncm-input-group-input" type="text" name={name} value={value || ''} onChange={handleOnChange} />
                <button type="button" className="ncm-input-group-btn" title="Buscar NCM" onClick={() => setModalNcm(true)}>
                    <PiMagnifyingGlassDuotone size={23} />
                </button>
            </div>

            <Modal
                modalStatus={modalNcm}
                changeStatus={setModalNcm}
                w={55}
                content={<NcmSearchModal onSelect={handlePicked} initialQuery={suggestQuery} />}
            />
        </>
    )
}

export default NcmSearchTrigger
